import axios from 'axios';
import { IApiResponse } from '../interfaces/IApiResponse';
import urls from './urls';

class PrivateAlbumApi {
  static getAlbumInfos(params: Record<string, any>): Promise<IApiResponse<any>> {
    return axios.get(urls.GET_PRIVATE_ALBUM_INFO, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getAlbumPhotos(userId: string | number, galleryId: string, params: { size: number; page: number }): Promise<IApiResponse<any>> {
    const url = urls.GET_ALBUM_PHOTOS.replace('{id}', `${userId}`).replace('{galleryId}', galleryId);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static grantedAccess(galleryId: string | number, friendId: string | number, expiredTime: number): Promise<IApiResponse<any>> {
    const params = { UserID: friendId, TimeOut: expiredTime };
    const url = urls.GRANT_USER_GALLERY_ACCESS.replace('{galleryId}', `${galleryId}`);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static removeGrantedAccess(galleryId: string | number, friendId: string | number): Promise<IApiResponse<any>> {
    const params = { ViewerIDs: [friendId] };
    const url = urls.DELETE_USER_GALLERY_ACCESS.replace('{galleryId}', `${galleryId}`);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getUserGalleryWithAccess(userId: string | number): Promise<IApiResponse<any>> {
    const url = `${urls.GET_USER_GALLERY_WITH_ACCESS}?UserID=${userId}&GalleryType=Private`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default PrivateAlbumApi;

const albumMock = [
  {
    PhotoID: 1,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 2,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/236x/33/e2/82/33e2827b522dce97e90564b6220b1666.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/236x/33/e2/82/33e2827b522dce97e90564b6220b1666.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 3,
    ThumbUrl: 'https://i.imgur.com/SQq5WP0.jpg',
    FullUrl: 'https://i.imgur.com/SQq5WP0.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 4,
    ThumbUrl:
      'https://3.bp.blogspot.com/-7SkqiGCXZis/V2mGQ0vHIvI/AAAAAAABbpo/NVkiFXNZw7cxmN0whvSpwGGKdwyaVqIRwCLcB/s1600/anh-gai-dep-dit-cong-4.jpg',
    FullUrl:
      'https://3.bp.blogspot.com/-7SkqiGCXZis/V2mGQ0vHIvI/AAAAAAABbpo/NVkiFXNZw7cxmN0whvSpwGGKdwyaVqIRwCLcB/s1600/anh-gai-dep-dit-cong-4.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 5,
    ThumbUrl: 'https://lh4.googleusercontent.com/-hFIdTnSrn88/VL5K8i4nxtI/AAAAAAAAFmc/PxgIbxI4lBE/s0/54be4aeea90ce.jpg',
    FullUrl: 'https://lh4.googleusercontent.com/-hFIdTnSrn88/VL5K8i4nxtI/AAAAAAAAFmc/PxgIbxI4lBE/s0/54be4aeea90ce.jpg',
    Height: 200,
    Width: 200,
  },
];
const albumMock3 = [
  {
    PhotoID: 1,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 2,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/236x/33/e2/82/33e2827b522dce97e90564b6220b1666.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/236x/33/e2/82/33e2827b522dce97e90564b6220b1666.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 3,
    ThumbUrl: 'https://i.imgur.com/SQq5WP0.jpg',
    FullUrl: 'https://i.imgur.com/SQq5WP0.jpg',
    Height: 200,
    Width: 200,
  },
];
const albumMock1 = [
  {
    PhotoID: 1,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    Height: 200,
    Width: 200,
  },
];
const albumMock2 = [
  {
    PhotoID: 1,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/originals/ff/60/2e/ff602e8567250c5a51ee64e3bfd0a938.jpg',
    Height: 200,
    Width: 200,
  },
  {
    PhotoID: 2,
    ThumbUrl: 'https://s-media-cache-ak0.pinimg.com/236x/33/e2/82/33e2827b522dce97e90564b6220b1666.jpg',
    FullUrl: 'https://s-media-cache-ak0.pinimg.com/236x/33/e2/82/33e2827b522dce97e90564b6220b1666.jpg',
    Height: 200,
    Width: 200,
  },
];
